module.exports = __webpack_public_path__ + "static/media/9-1.680a2aa5.jpg";